import { InputText } from 'primereact/inputtext';
import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

type BetweenFilterProps = {
  placeholder?: string[];
  value?: { from?: string | undefined; to?: string | undefined };
  field: string;
  onChange: (
    value: { value: { from?: string | undefined; to?: string | undefined } },
    field: string,
  ) => void;
};

export const DataTableBetweenFilter: React.FC<BetweenFilterProps> = ({
  field,
  placeholder,
  onChange,
  value,
}) => {
  const { t } = useTranslation();

  const [values, setValues] = useState<{ from: string; to: string }>({
    from: value && value.from ? value.from : '',
    to: value && value.to ? value.to : '',
  });

  const onInputChange = (
    event: ChangeEvent<HTMLInputElement>,
    type: 'from' | 'to',
  ) => {
    const nextState = {
      ...values,
      [type]: event.currentTarget.value,
    };
    setValues(nextState);
    onChange(
      {
        value: nextState,
      },
      field,
    );
  };
  const [fromId, toId] = [`from-${field}`, `to-${field}`];
  return (
    <div className="flex align-items-center">
      <InputText
        id={fromId}
        defaultValue={value && value.from ? value.from : undefined}
        placeholder={placeholder && placeholder[0] ? placeholder[0] : undefined}
        onChange={(event) => onInputChange(event, 'from')}
        autoComplete="off"
      />
      <span className="mx-2">{t('tables.to')}</span>
      <InputText
        id={toId}
        defaultValue={value && value.to ? value.to : undefined}
        placeholder={placeholder && placeholder[1] ? placeholder[1] : undefined}
        onChange={(event) => onInputChange(event, 'to')}
        autoComplete="off"
      />
    </div>
  );
};
